import { render, staticRenderFns } from "./EffectiveDate.vue?vue&type=template&id=745bfe42&scoped=true"
import script from "./EffectiveDate.vue?vue&type=script&lang=ts"
export * from "./EffectiveDate.vue?vue&type=script&lang=ts"
import style0 from "./EffectiveDate.vue?vue&type=style&index=0&id=745bfe42&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "745bfe42",
  null
  
)

export default component.exports